import { render, staticRenderFns } from "./CreatePdfArchiveModal.vue?vue&type=template&id=337726d9"
import script from "./CreatePdfArchiveModal.vue?vue&type=script&lang=ts"
export * from "./CreatePdfArchiveModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337726d9')) {
      api.createRecord('337726d9', component.options)
    } else {
      api.reload('337726d9', component.options)
    }
    module.hot.accept("./CreatePdfArchiveModal.vue?vue&type=template&id=337726d9", function () {
      api.rerender('337726d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-archive/CreatePdfArchiveModal.vue"
export default component.exports